import db from "./db";

// Deliberately preserve pendingOps: these are unsynced staff work, not a cache.
export async function clearClientCaches() {
  await db.clients.clear();
  await db.syncMeta.delete("clients_last_synced");
  if ("caches" in window) await window.caches.delete("api-clients-cache");
}
